import React, { useRef } from "react";
import styled from "styled-components";
import LabelWithTooltip, {LABEL_CONTAINER_CLASS, labelLayoutStyles} from "widgets/components/LabelWithTooltip";
import UploadImageWidget from "byk/pages/components/UploadImageWidget";
import {LabelPosition} from "components/constants";
import {strToJson} from "@byk/utils/Utils";
import _ from "lodash";

export const DivContainer = styled.div<any>`
  ${labelLayoutStyles}

  & .${LABEL_CONTAINER_CLASS} {
    align-self: flex-start;
    ${({labelPosition}) =>
  labelPosition === LabelPosition.Left && "min-height: 30px"};
  }

  .ant-upload{

     border-radius: ${({ borderRadius }) => borderRadius ||'0px'} !important;
     box-shadow: ${({ boxShadow }) => boxShadow ||'none'} !important;
     background:  ${({ib_bgColor}) => ib_bgColor ? ib_bgColor : 'var(--wds-color-bg)'} !important;

     color: ${({it_color}) => {
      return (it_color ? `${it_color}` : "var(--wds-color-text)") + ' !important'
      }};
     font-size: ${({it_size}) => {
        return (it_size ? `${it_size}` : "14px") + ' !important'
      }};
  }
  .ant-upload-select-picture-card {
    border-width: ${({ borderWidth }) => `${borderWidth}px  !important`};
    border-color: ${({ ib_borderColor }) => ib_borderColor} !important;
  }

  .ant-upload-select-picture-card:hover {
    border-width: ${({ borderWidth }) => `${borderWidth}px  !important`};
    border-color: ${({ accentColor }) => accentColor} !important;
  }

  .ant-upload.ant-upload-disabled {
    pointer-events: none;
    background-color: var(--wds-color-bg-disabled) !important;
    color: var(--wds-color-text-disabled) !important;
    box-shadow: none !important;
    border-color: var(--wds-color-border-disabled) !important;
  }
`;

function UploadImageComponent(props: any) {
  const {
    wrapperRef,
    //LABEL START
    compactMode,
    isDisabled,
    isLoading,
    isRequired,
    labelAlignment,
    labelPosition,
    labelStyle,
    label,
    labelTextColor,
    labelTextSize,
    labelTooltip,
    labelWidth,
    onRadioSelectionChange,
    value,
    fileSize,
    fileCount,
    btnText,
    accept,
    updateValue,
    isReadonly,
    fileList,
    it_color,
    it_size,
    it_style,
    ib_bgColor,
    ib_borderColor,
    ib_iconColor,
    borderWidth,
    borderRadius,
    boxShadow,
    accentColor,
    previewSize,
  } = props;
  const dataCache = useRef([]);
  const dataCacheUUID = useRef([]);
  const setUploadData = (data: any) => {
    updateValue(data);
  }
  const setLogoRef = (url: string, isClear: boolean = false) => {
  }

  const getValue = (value: any, fileList: any) => {
    if(_.isEqual(dataCache.current, value)||_.isEmpty(value)){
      return dataCacheUUID.current;
    }
    let _v =(!_.isEmpty(fileList))&& fileList!="[]"?fileList:value;
    let _r:any=strToJson(_v);
    dataCache.current = value;
    dataCacheUUID.current  = _r;
    return _r;
  }

  return (
    <>
      <DivContainer
        compactMode={compactMode}
        data-testid="radiogroup-container"
        labelPosition={labelPosition}
        borderRadius={borderRadius}
        borderWidth ={borderWidth}
        boxShadow={boxShadow}
        it_color={it_color}
        it_size={it_size}
        it_style={it_style}
        ib_bgColor={ib_bgColor}
        ib_borderColor={ib_borderColor}
        ib_iconColor={ib_iconColor}
        accentColor = {accentColor}
        isDisabled={isDisabled}
      >
        {label && (
          <LabelWithTooltip
            className={`datepicker-label`}
            text={label}
            cyHelpTextClassName="datepicker-tooltip"
            alignment={labelAlignment}
            color={labelTextColor}
            compact={compactMode}
            disabled={isDisabled}
            fontSize={labelTextSize}
            fontStyle={labelStyle}
            helpText={labelTooltip}
            isDynamicHeightEnabled={true}
            loading={isLoading}
            position={labelPosition}
            width={labelWidth}
            isRequired={isRequired}
          />
        )}
        <UploadImageWidget
          onEmit={(data: string) => setUploadData(data)}
          onEmitClear={() => setLogoRef("", true)}
          accept={accept}
          disabled={isDisabled}
          isReadonly={isReadonly}
          fileSize={fileSize}
          fileCount={fileCount}
          btnText={btnText}
          value={getValue(value, fileList)}
          previewSize={previewSize}
        />

      </DivContainer>
    </>
  )
}

export default UploadImageComponent;
